export function ImageSizeControls (pEditor, pImage)
{
  var pThis = this;

  pThis.select = select;
  pThis.deselect = deselect;

  pThis.isSelMoving = false;

  var container = null,
      containerId = 'idEditorImageElementControlsContainer_' + pEditor.editorId,
      controlsId = 'idEditorImageElementControls_' + pEditor.editorId,
      controls = [],

      controlResizeableParts =
      [
        {'moveTag': '6', 'cursor': 'nw-resize'},
        {'moveTag': '4', 'cursor': 'n-resize'},
        {'moveTag': '7', 'cursor': 'ne-resize'},
        {'moveTag': '3', 'cursor': 'e-resize'},
        {'moveTag': '9', 'cursor': 'nw-resize'},
        {'moveTag': '5', 'cursor': 'n-resize'},
        {'moveTag': '8', 'cursor': 'ne-resize'},
        {'moveTag': '2', 'cursor': 'e-resize'}
      ],

      mStruct = {},

      selElement,
      cutBoxCoords,
      oldSelElementLeft,
      oldSelElementTop,
      oldSelElementWidth,
      oldSelElementHeight,
      currentScrollLeft,
      currentScrollTop,
      savedScrollLeft,
      savedScrollTop,
      currentScrollLeftIFrame,
      currentScrollTopIFrame,
      savedScrollLeftIFrame,
      savedScrollTopIFrame,
      isSelMoved = false,
      setControlsPositionTM = null;

  create();


  function create ()
  {
    var i,
        controlMoveTag,
        controlLeft,
        controlRight,
        controlTop,
        controlBottom,
        controlWidth,
        controlHeight,
        controlZIndex,
        controlMarginLeft,
        controlMarginTop,
        controlVisibility,
        controlBorder,
        controlBackground,
        controlCursor,
        str = '';

    container = BEditor.environment.topWindow.document.createElement('DIV');
    container.id = containerId;
    container.setAttribute('moveTag', '1');
    container.setAttribute('style', 'position: absolute; left: -3700px; top: -3700px; width: 0; height: 0; z-index: 37753; visibility: hidden; white-space: nowrap; cursor: move;');

    for (i = 0; i < 8; i++)
    {
      controlLeft = 'auto';
      controlRight = 'auto';
      controlTop = 'auto';
      controlBottom = 'auto';
      controlMarginLeft = '';
      controlMarginTop = '';

      if (i === 0 || i === 6 || i === 7)
      {
        controlLeft = '-7px';
      }
      else if (i === 2 || i === 3 || i === 4)
      {
        controlRight = '-7px';
      }

      if (i === 0 || i === 1 || i === 2)
      {
        controlTop = '-7px';
      }
      else if (i === 4 || i === 5 || i === 6)
      {
        controlBottom = '-7px';
      }

      if (i === 1 || i === 5)
      {
        controlLeft = '50%';
        controlMarginLeft = 'margin-left: -4px;';
      }
      else if (i === 3 || i === 7)
      {
        controlTop = '50%';
        controlMarginTop = 'margin-top: -4px;';
      }

      controlMoveTag = controlResizeableParts[i]['moveTag'];
      controlWidth = '5px';
      controlHeight = '5px';
      controlZIndex = '37773';
      controlVisibility = '';
      controlBorder = 'border: 1px solid #000000;';
      controlBackground = '#FFFFFF';
      controlCursor = controlResizeableParts[i]['cursor'];

      str += '<div id="' + controlsId + '_' + i + '" moveTag="' + controlMoveTag + '" style="position: absolute; left: ' + controlLeft + '; right: ' + controlRight + '; top: ' + controlTop + '; bottom: ' + controlBottom + '; width: ' + controlWidth + '; height: ' + controlHeight + '; z-index: ' + controlZIndex + ';' + controlMarginLeft + controlMarginTop + ' overflow: hidden;' + controlVisibility + controlBorder + ' background: ' + controlBackground + '; cursor: ' + controlCursor + '; pointer-events: auto;"></div>';
    }

    container.innerHTML = str;
    container.style.pointerEvents = 'none';

    BEditor.environment.topWindow.document.body.appendChild(container);

    for (i = 0; i < 8; i++)
    {
      controls[i] = BEditor.domHelpers.$(controlsId + '_' + i);
      BEditor.domHandlers.addHandler(controls[i], 'mousedown', startMoveElement);
    }
  }


  function select (element)
  {
    selElement = element;

    container.style.visibility = 'visible';

    if (setControlsPositionTM) clearInterval(setControlsPositionTM);
    setControlsPositionTM = setInterval(setControlsPosition, 37);
  }


  function setControlsPosition (isForced)
  {
    var currentFullScroll,
        selElementCoords,
        selElementWidth,
        selElementHeight;

    if (!selElement || !container)
    {
      deselect();
      return false;
    }

    if (pThis.isSelMoving)
    {
      return true;
    }

    selElementCoords = BEditor.dimensions.getElementXY(selElement, pEditor.iFrame);
    selElementWidth = selElement.offsetWidth;
    selElementHeight = selElement.offsetHeight;

    if (!selElementCoords.X && !selElementCoords.Y && !selElementWidth && !selElementHeight)
    {
      selElementWidth = selElement.getAttribute('data-initwidth');
      selElementHeight = selElement.getAttribute('data-initheight');

      if (!selElementCoords.X && !selElementCoords.Y && (!selElementWidth || !selElementHeight))
      {
        deselect();
        return false;
      }
      else
      {
        selElementWidth *= 1;
        selElementHeight *= 1;
      }
    }
    else
    {
      selElement.removeAttribute('data-initwidth');
      selElement.removeAttribute('data-initheight');
    }

    selElementCoords.realX = selElementCoords.X - pEditor.frameSize.cloneEditableAreaCoords.paddingLeft;
    selElementCoords.realY = selElementCoords.Y - pEditor.frameSize.cloneEditableAreaCoords.paddingTop;

    currentFullScroll = pEditor.isNewFullScroll ? BEditor.window.getFullScroll(pEditor.objIFrame, pEditor.$winContent, { limiters: pEditor.scrollableParents }) : BEditor.window.getScroll(pEditor.$winContent); //TODO:Dime Test scrolling contentarea & iframe
    currentScrollLeft = currentFullScroll.left;
    currentScrollLeftIFrame = BEditor.window.getScrollLeft(pEditor.iFrame);
    currentScrollTop = currentFullScroll.top;
    currentScrollTopIFrame = BEditor.window.getScrollTop(pEditor.iFrame);

    if (isForced || container.style.left === '-3700px' || selElementCoords.realX != oldSelElementLeft || selElementCoords.realY != oldSelElementTop ||
        selElementWidth != oldSelElementWidth || selElementHeight != oldSelElementHeight ||
        currentScrollLeft != savedScrollLeft || currentScrollLeftIFrame != savedScrollLeftIFrame || currentScrollTop != savedScrollTop || currentScrollTopIFrame != savedScrollTopIFrame)
    {
      oldSelElementLeft = selElementCoords.realX;
      oldSelElementTop = selElementCoords.realY;
      oldSelElementWidth = selElementWidth;
      oldSelElementHeight = selElementHeight;
      savedScrollLeft = currentScrollLeft;
      savedScrollLeftIFrame = currentScrollLeftIFrame;
      savedScrollTop = currentScrollTop;
      savedScrollTopIFrame = currentScrollTopIFrame;

      cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);

      container.style.left = (cutBoxCoords.X - currentScrollLeft + selElementCoords.realX - currentScrollLeftIFrame) + 'px';
      container.style.top = (cutBoxCoords.Y - currentScrollTop + selElementCoords.realY - currentScrollTopIFrame) + 'px';
      container.style.width = (selElementWidth) + 'px';
      container.style.height = (selElementHeight) + 'px';
    }
  }


  function startMoveElement (e)
  {
    var currentFullScroll,
        containerCoords,
        selElementCoords,
        naturalRatioHeight;

    if (e && e.currentTarget && container && selElement)
    {
      e.stopPropagation();
      e.preventDefault();

      pImage.ieditor.hideImageSettingsToolBar();
      pImage.controls.hideControlsTemp();

      pThis.isSelMoving = true;

      currentFullScroll = pEditor.isNewFullScroll ? BEditor.window.getFullScroll(pEditor.objIFrame, pEditor.$winContent, { limiters: pEditor.scrollableParents }) : BEditor.window.getScroll(pEditor.$winContent); //TODO:Dime Test scrolling contentarea & iframe
      currentScrollLeft = currentFullScroll.left;
      currentScrollLeftIFrame = BEditor.window.getScrollLeft(pEditor.iFrame);
      currentScrollTop = currentFullScroll.top;
      currentScrollTopIFrame = BEditor.window.getScrollTop(pEditor.iFrame);

      selElementCoords = BEditor.dimensions.getElementBox(selElement);
      mStruct.startX = e.screenX;
      mStruct.startY = e.screenY;
      mStruct.X = mStruct.startX;
      mStruct.Y = mStruct.startY;
      mStruct.containerLeft = container.offsetLeft;
      mStruct.containerTop = container.offsetTop;

      mStruct.currentScrollLeft = currentScrollLeft;
      mStruct.currentScrollLeftIFrame = currentScrollLeftIFrame;
      mStruct.currentScrollTop = currentScrollTop;
      mStruct.currentScrollTopIFrame = currentScrollTopIFrame;

      mStruct.left = mStruct.containerLeft - (cutBoxCoords.X - currentScrollLeft);
      mStruct.top = mStruct.containerTop - (cutBoxCoords.Y - currentScrollTop);
      mStruct.width = container.offsetWidth;
      mStruct.height = container.offsetHeight;
      mStruct.right = mStruct.left + mStruct.width;
      mStruct.bottom = mStruct.top + mStruct.height;

      mStruct.screenDeltaX = e.screenX - e.clientX;
      mStruct.screenDeltaY = e.screenY - e.clientY;

      containerCoords = BEditor.dimensions.getElementXY(container, pEditor.iFrame);
      mStruct.screenLeft = containerCoords.left + mStruct.screenDeltaX;
      mStruct.screenTop = containerCoords.top + mStruct.screenDeltaY;
      mStruct.screenRight = containerCoords.right + mStruct.screenDeltaX;
      mStruct.screenBottom = containerCoords.bottom + mStruct.screenDeltaY;

      mStruct.elementLeft = selElement.offsetLeft;
      mStruct.elementTop = selElement.offsetTop;

      mStruct.elementWidth = selElement.offsetWidth;
      mStruct.elementHeight = selElement.offsetHeight;
      mStruct.elementRatio = selElement.offsetWidth / selElement.offsetHeight;
      mStruct.isElementStyleWidth = !!(selElement.style.width);
      mStruct.isElementStyleHeight = !!(selElement.style.height);

      naturalRatioHeight = selElement.offsetWidth / (selElement.naturalWidth / selElement.naturalHeight);
      mStruct.isNaturalRatio = (selElement.offsetHeight === Math.floor(naturalRatioHeight) || selElement.offsetHeight === Math.round(naturalRatioHeight));
      mStruct.isResponsiveStyle = (BEditor.styleHelpers.getElementStyle(selElement, 'maxWidth') === '100%' && (selElement.style.height === '' || selElement.style.height === 'auto'));

      mStruct.controlElement = e.target;
      mStruct.moveTag = parseInt(mStruct.controlElement.getAttribute('moveTag')) || 1;
      mStruct.mouseDir = 0;

      selElement.setAttribute('width', mStruct.elementWidth);
      selElement.setAttribute('height', mStruct.elementHeight);

      cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);
      cutBoxCoords.width = pEditor.cutBox.offsetWidth;
      cutBoxCoords.height = pEditor.cutBox.offsetHeight;

      moveElement(e);
    }
    else
    {
      moveElementDo(e, null);
    }
  }


  function moveElement (e)
  {
    var eType, eButton, eX, eY;

    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);

    if (e && mStruct.controlElement)
    {
      e.stopPropagation();
      e.preventDefault();

      eType = e.type;
      eButton = e.button;
      eX = e.screenX;
      eY = e.screenY;
      mStruct.shiftKey = e.shiftKey;

      moveElementDo(e, eType, eButton, eX, eY);
    }
    else
    {
      moveElementDo(e, null);
    }
  }


  function moveElementDo (e, eType, eButton, eX, eY)
  {
    var deltaX,
        deltaY,
        currentElementLeft,
        currentElementTop,
        containerDeltaLeft,
        containerDeltaTop;

    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);

    if (!selElement || !selElement.parentNode || !container)
    {
      deselect();
      return false;
    }

    if (eType == null)
    {
      pThis.isSelMoving = false;
      mStruct.pushMouseLeftButton = false;
      removeImageElementHandler();
      setMovedElementXY();
      pEditor.undoRedo.isStopSaveUndo = false;
      pEditor.undoRedo.saveUndo(true);
    }
    else
    {
      if (eType == 'mousedown')
      {
        pEditor.undoRedo.isStopSaveUndo = true;
        pEditor.contentChecker.setExcludeWordCheck();

        if (eButton == 0 || eButton == 1)
        {
          pThis.isSelMoving = true;
          mStruct.pushMouseLeftButton = true;
          addImageElementHandler();
        }
        else
        {
          pThis.isSelMoving = false;
          mStruct.pushMouseLeftButton = false;
          removeImageElementHandler();
          setMovedElementXY();
        }
      }
      else if (eType == 'mouseup' || eType == 'mouseout')
      {
        pThis.isSelMoving = false;
        mStruct.pushMouseLeftButton = false;
        removeImageElementHandler();
        setMovedElementXY();
        pEditor.undoRedo.isStopSaveUndo = false;
        pEditor.undoRedo.saveUndo(true);
      }
      else if (eType == 'mousemove' && mStruct.pushMouseLeftButton)
      {
        if (mStruct.moveTag)
        {
          deltaX = eX - mStruct.X;
          deltaY = eY - mStruct.Y;

          if (mStruct.mouseDir === 4 || mStruct.mouseDir === 5)
          {
            if (eX < mStruct.screenLeft)
            {
              mStruct.mouseDir = 2;
            }
            else if (eX > mStruct.screenRight)
            {
              mStruct.mouseDir = 3;
            }
          }
          else
          {
            if (eY < mStruct.screenTop)
            {
              mStruct.mouseDir = 4;
            }
            else if (eY > mStruct.screenBottom)
            {
              mStruct.mouseDir = 5;
            }
          }

          if(mStruct.moveTag === 2 || mStruct.moveTag === 6 || mStruct.moveTag === 8)
          {
            deltaX = -deltaX;
          }

          if(mStruct.moveTag === 4 || mStruct.moveTag === 6 || mStruct.moveTag === 7)
          {
            deltaY = -deltaY;
          }

          if (mStruct.isResponsiveStyle && mStruct.isNaturalRatio)
          {
            if (mStruct.moveTag === 2 || mStruct.moveTag === 3 || mStruct.mouseDir === 2 || mStruct.mouseDir === 3)
            {
              mStruct.width += deltaX;
              mStruct.height = Math.round(mStruct.width / mStruct.elementRatio);
            }
            else
            {
              mStruct.height += deltaY;
              mStruct.width = Math.round(mStruct.height * mStruct.elementRatio);
            }
          }
          else
          {
            if (mStruct.moveTag === 2 || mStruct.moveTag === 3)
            {
              mStruct.width += deltaX;

            }
            else if (mStruct.moveTag === 4 || mStruct.moveTag === 5)
            {
              mStruct.height += deltaY;
            }
            else
            {
              if (mStruct.mouseDir === 2 || mStruct.mouseDir === 3)
              {
                mStruct.width += deltaX;
                mStruct.height = Math.round(mStruct.width / mStruct.elementRatio);
              }
              else
              {
                mStruct.height += deltaY;
                mStruct.width = Math.round(mStruct.height * mStruct.elementRatio);
              }
            }
          }

          if (mStruct.width < 1)
          {
            mStruct.width = 1;

            if (mStruct.moveTag === 6 || mStruct.moveTag === 7 || mStruct.moveTag === 8 || mStruct.moveTag === 9)
            {
              mStruct.height = Math.round(mStruct.width / mStruct.elementRatio);
            }
          }

          if (mStruct.height < 1)
          {
            mStruct.height = 1;
          }

          container.style.width = mStruct.width + 'px';
          selElement.setAttribute('width', mStruct.width);

          if (mStruct.isElementStyleWidth)
          {
            selElement.style.width = mStruct.width + 'px';
          }

          mStruct.X = eX;

          currentElementLeft = selElement.offsetLeft;
          containerDeltaLeft = currentElementLeft - mStruct.elementLeft;
          mStruct.containerLeft += containerDeltaLeft;
          mStruct.containerLeft += ((mStruct.currentScrollLeft - pEditor.$winContent.pageXOffset) + (mStruct.currentScrollLeftIFrame - pEditor.iFrame.pageXOffset));
          container.style.left = mStruct.containerLeft + 'px';
          mStruct.elementLeft = currentElementLeft;
          mStruct.screenLeft += containerDeltaLeft;
          mStruct.screenRight = mStruct.screenLeft + mStruct.width;
          mStruct.currentScrollLeft = pEditor.$winContent.pageXOffset;
          mStruct.currentScrollLeftIFrame = pEditor.iFrame.pageXOffset;

          container.style.height = mStruct.height + 'px';
          selElement.setAttribute('height', mStruct.height);

          if (mStruct.isElementStyleHeight)
          {
            selElement.style.height = mStruct.height + 'px';
          }

          mStruct.Y = eY;

          currentElementTop = selElement.offsetTop;
          containerDeltaTop = currentElementTop - mStruct.elementTop;
          mStruct.containerTop += containerDeltaTop;
          mStruct.containerTop += ((mStruct.currentScrollTop - pEditor.$winContent.pageYOffset) + (mStruct.currentScrollTopIFrame - pEditor.iFrame.pageYOffset));
          container.style.top = mStruct.containerTop + 'px';
          mStruct.elementTop = currentElementTop;
          mStruct.screenTop += containerDeltaTop;
          mStruct.screenBottom = mStruct.screenTop + mStruct.height;
          mStruct.currentScrollTop = pEditor.$winContent.pageYOffset;
          mStruct.currentScrollTopIFrame = pEditor.iFrame.pageYOffset;

          isSelMoved = true;
        }
      }
    }
  }


  function moveOut()
  {
    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);
    mStruct.tmMoveOut = setTimeout(function() { moveElementDo(null, null); }, 100);
  }


  function moveOver()
  {
    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);
  }


  function setMovedElementXY ()
  {
    var currentFullScroll,
        containerWidth,
        containerHeight;

    cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);
    cutBoxCoords.width = pEditor.cutBox.offsetWidth;
    cutBoxCoords.height = pEditor.cutBox.offsetHeight;

    currentFullScroll = pEditor.isNewFullScroll ? BEditor.window.getFullScroll(pEditor.objIFrame, pEditor.$winContent, { limiters: pEditor.scrollableParents }) : BEditor.window.getScroll(pEditor.$winContent); //TODO:Dime Test scrolling contentarea & iframe
    currentScrollLeft = currentFullScroll.left;
    currentScrollLeftIFrame = BEditor.window.getScrollLeft(pEditor.iFrame);
    currentScrollTop = currentFullScroll.top;
    currentScrollTopIFrame = BEditor.window.getScrollTop(pEditor.iFrame);

    containerWidth = Math.max(container.offsetWidth, 1);
    containerHeight = Math.max(container.offsetHeight, 1);

    container.style.width = containerWidth + 'px';
    container.style.height = containerHeight + 'px';

    if (containerWidth === selElement.naturalWidth && containerHeight === selElement.naturalHeight)
    {
      selElement.removeAttribute('width');
      selElement.removeAttribute('height');
    }
    else
    {
      selElement.setAttribute('width', containerWidth);
      selElement.setAttribute('height', containerHeight);
    }
  }


  function addImageElementHandler ()
  {
    mStruct.controlElement.addEventListener('mouseout', moveOut, false);
    mStruct.controlElement.addEventListener('mouseover', moveOver, false);

    pEditor.iFrameDoc.addEventListener('mousemove', moveElement, false);
    pEditor.iFrameDoc.addEventListener('mouseup', moveElement, false);
    pEditor.iFrameDoc.addEventListener('mouseout', moveOut, false);
    pEditor.iFrameDoc.addEventListener('mouseover', moveOver, false);

    pEditor.$winContent.document.addEventListener('mousemove', moveElement, false);
    pEditor.$winContent.document.addEventListener('mouseup', moveElement, false);
    pEditor.$winContent.document.addEventListener('mouseout', moveOut, false);
    pEditor.$winContent.document.addEventListener('mouseover', moveOver, false);

    BEditor.environment.topWindow.document.addEventListener('mousemove', moveElement, false);
    BEditor.environment.topWindow.document.addEventListener('mouseup', moveElement, false);
    BEditor.environment.topWindow.document.addEventListener('mouseout', moveOut, false);
    BEditor.environment.topWindow.document.addEventListener('mouseover', moveOver, false);
  }


  function removeImageElementHandler ()
  {
    if (mStruct.tmMoveOut) clearTimeout(mStruct.tmMoveOut);

    if (mStruct && mStruct.controlElement)
    {
      mStruct.controlElement.removeEventListener('mouseout', moveOut, false);
      mStruct.controlElement.removeEventListener('mouseover', moveOver, false);
    }

    pEditor.iFrameDoc.removeEventListener('mousemove', moveElement, false);
    pEditor.iFrameDoc.removeEventListener('mouseup', moveElement, false);
    pEditor.iFrameDoc.removeEventListener('mouseout', moveOut, false);
    pEditor.iFrameDoc.removeEventListener('mouseover', moveOver, false);

    pEditor.$winContent.document.removeEventListener('mousemove', moveElement, false);
    pEditor.$winContent.document.removeEventListener('mouseup', moveElement, false);
    pEditor.$winContent.document.removeEventListener('mouseout', moveOut, false);
    pEditor.$winContent.document.removeEventListener('mouseover', moveOver, false);

    BEditor.environment.topWindow.document.removeEventListener('mousemove', moveElement, false);
    BEditor.environment.topWindow.document.removeEventListener('mouseup', moveElement, false);
    BEditor.environment.topWindow.document.removeEventListener('mouseout', moveOut, false);
    BEditor.environment.topWindow.document.removeEventListener('mouseover', moveOver, false);
  }


  function deselect (e)
  {
    if (!e || !e.target || !selElement || e.target != selElement)
    {
      pEditor.undoRedo.isStopSaveUndo = true;

      if (setControlsPositionTM) clearInterval(setControlsPositionTM);

      if (container)
      {
        container.style.visibility = 'hidden';
        container.style.left = '-3700px';
        container.style.top = '-3700px';
      }

      if (selElement)
      {
        if (selElement.getAttribute('data-selected'))
        {
          selElement.removeAttribute('data-selected');
        }
      }

      removeImageElementHandler();

      pThis.isSelMoving = false;
      selElement = null;
      pImage.webkitSelectedImage = null;
      pEditor.undoRedo.saveUndoDo(true);
      pEditor.undoRedo.isStopSaveUndo = false;
    }
  }

}
